import { IOrganization } from '@tickeat/types';
import { crudEndpointsFactory } from '../crud-endpoints.factory';
import { OrganizationFormValues } from '@app/features/Organization/organization-form.helpers';

export const organizationApi = crudEndpointsFactory<IOrganization>()('organizations', 'Organizations').injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    updateOneOrganizations: builder.mutation<IOrganization, OrganizationFormValues>({
      query: (body) => ({
        url: 'organizations',
        method: 'PUT',
        body,
      }),
    }),
    connectOrganizationToHubrise: builder.mutation({
      query: (body) => ({
        url: 'organizations/hubrise',
        method: 'POST',
        body,
      }),
    }),
  }),
});
